module.exports = __webpack_public_path__ + "img/twbgsch_bg.f503314c.png";